import React from "react";
import * as Mui from "@mui/material";
import { connect } from "react-redux";
import * as env from "shared/env";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { IntegrationType } from "type/integration-type";

const mapStateToProps = (state: RootState) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	saveIntegration,
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>
{
	integrationType: IntegrationType;
	onClose: Function;
}

class Component extends React.Component<Props> {

	public render() {
		const { integrationType, onClose, saveIntegration } = this.props;
		return (
			<Mui.Button
				variant="contained"
				color={"primary"}
				style={{ marginRight: 8 }}
				onClick={() => {
					saveIntegration({ integration: {
						integrationType,
						data: {},
					}})
					onClose();
				}}
			>
				Add
			</Mui.Button>
		);
	}

}

export const AddButton = connect(mapStateToProps, mapDispatchToProps)(Component);
